import Vue from 'vue';
import { Carousel3d, Slide } from 'vue-carousel-3d';
import VueSlider from 'vue-slider-component';
import Datepicker from 'vuejs-datepicker';
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import cloneDeep from 'lodash/cloneDeep';
import VModal from 'vue-js-modal'
import * as utils from './utils';
import {ELECTRICITY_CONTRACT_DATA_SESSION_STORAGE_KEY, FORM_STAGES} from './constants';
import { initialState } from "./state";
import * as moment from "moment";

Vue.use(Tooltip);
Vue.use(VModal);

new Vue({
    el: '#electricity-contract-page',
    name: 'app',
    mixins: [],
    data: {...initialState },
    components: {
        datepicker: Datepicker,
        carousel: Carousel3d,
        slide: Slide,
        slider: VueSlider
    },
    methods: {
        async initialize() {
            this.isInitialized = true;
            await this.fetchElectricityContracts();
            this.fetchElectricityMeasurementTypes();
            this.fetchHousingTypes();
            this.fetchYearlySpotPriceTotal();
            this.fetchBillingIntervals();
        },
        roundedFloat(val) {
            return utils.roundedFloat(val);
        },
        getNewProductId(old_product_id) {
            switch (old_product_id) {
                case 9: return 637; // Spot el
                case 12: return 717; // Spot el 100% förnybar
                case 1: return 671; // Allman el
                case 13: return 720; // Allman el 100% förnybar
                default: return 0;
            }
        },
        goToNewPortal(productId) {
            const language = document.documentElement.lang.substring(0, 2);
            const newProductId = this.getNewProductId(productId);

            let newUrl = "https://portal.herrfors.fi/";

            if (language === "sv") {
                newUrl += "sv-FI";
            } else if (language === "fi") {
                newUrl += "fi-FI";
            } else {
                newUrl += "en-GB";
            }

            if (newProductId > 0) {
                newUrl += "/contracts/sign?productId="+newProductId+"&clientType=private";
            }

            window.location.href = newUrl;
            return false;
        },
        goForward(product) {
            if (product && product.ID) {
                this.goToNewPortal(product.ID);
            }
            this.goBack();
        },
        goBack() {
            this.formStage = FORM_STAGES.SELECT_PRODUCT_STAGE;
            this.form.selectedProduct = null;
        },
        validateEmail() {
           return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.form.registration.email)
        },
        validateSecondPersonEmail() {
            return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.form.registration.secondPersonEmail);
        },
        validateNumbers(value) {
            return /^[0-9]/.test(value)
        },
        goToForm(product,url){
            this.goToNewPortal(product.ID);
        },
        submitForm: async function() {
            this.goToNewPortal(this.form.selectedProduct.ID);
        },
        submitMultiPersonForm: async function() {
            this.goToNewPortal(this.form.selectedProduct.ID);
        },
        submitMultiPersonFormVerification: async function() {
            this.goToNewPortal(this.form.multiPersonRegistration.productID);
        },
        setDefaultHousingType() {
            const urlParams = new URLSearchParams(window.location.search);
            const housingTypeGetVar = urlParams.get('housingType');
            this.presetHousingType = this.housingTypes.find(type => type.Name === housingTypeGetVar);

            if (this.presetHousingType && !this.form.selectedHousingType) {
                this.form.selectedHousingType = this.presetHousingType;
            }
        },
        getBaseUrl() {
            return window.location.href.replace(window.location.search, '').replace(/\/?$/, '/');
        },
        isMobileDevice() {
            if (navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i)
            ) {
                return true;
            } else {
                return false;
            }
        },
        productHasSelectedMeasurementType(product) {
            const foundElectricityMeasurementTypes = product.ElectricityMeasurementTypes.find(type =>
                type.ID === (this.form.selectedMeasurementType && this.form.selectedMeasurementType.ID)
            );

            const foundHousingType = product.HousingTypes.find(type =>
                type.ID === (this.form.selectedHousingType && this.form.selectedHousingType.ID)
            );

            return foundElectricityMeasurementTypes && foundHousingType;
        },
        getProductsByMeasurmentType(type) {
            const products = this.electricityContractProducts;
            const productData = products.filter(product => product.ElectricityMeasurementTypes.find(mType => mType.ID === type));

            productData.forEach(product => {
                product.calculatedPrices = this.getProductFeesForProduct(product.ID);
                product.baseFee = product[`BaseFee_${product.selectedContractType}`];
                product.generalFee = product[`GenFee_${product.selectedContractType}`];
                product.yearlyEstimatedConsumption = 2000;
                product.eurokWh = product.generalFee / 100;
                product.dayPrice = product[`DayFee_${product.selectedContractType}`];
                product.nightPrice = product[`NightFee_${product.selectedContractType}`];
                product.seasonalFee_27 = product[`SeasonalFee27_${product.selectedContractType}`];
                product.seasonalFee_73 = product[`SeasonalFee73_${product.selectedContractType}`];
                product.winterFee = product[`WinterFee_${product.selectedContractType}`];
                product.spotFee = product[`SpotFee_${product.selectedContractType}`];
                product.ifSpotPriceProduct = product.SpotPriceProduct;
            });

            return productData;
        },
        getProductFeesForProduct(productId) {
            const products = this.electricityContractProducts;
            const product = products.find(product => product.ID == productId);

            if (!product) {
                return null;
            }
            /*
                Calculate fees shown on product based on selected contract duration in months.
            */
            const baseFee = product[`BaseFee_${product.selectedContractType}`];
            const generalFee = product[`GenFee_${product.selectedContractType}`];
            const yearlyEstimatedConsumption = 2000;
            const eurokWh = generalFee / 100;
            const dayPrice = product[`DayFee_${product.selectedContractType}`];
            const nightPrice = product[`NightFee_${product.selectedContractType}`];
            const seasonalFee_27 = product[`SeasonalFee27_${product.selectedContractType}`];
            const seasonalFee_73 = product[`SeasonalFee73_${product.selectedContractType}`];
            const winterFee = product[`WinterFee_${product.selectedContractType}`];
            const spotFee = product[`SpotFee_${product.selectedContractType}`];
            const ifSpotPriceProduct = product.SpotPriceProduct;
            const margin = product.SpotMarginCents;
            if (dayPrice && nightPrice) {
                return utils.calculateDayAndNightPrice(product, dayPrice, nightPrice, yearlyEstimatedConsumption, baseFee);
            } else if (seasonalFee_27 && seasonalFee_73) {
                return utils.calculateSeasonalPrices(product, yearlyEstimatedConsumption, seasonalFee_27, seasonalFee_73, baseFee);
            } else if (winterFee && spotFee) {
                return utils.calculateWinterAndSpotPrices(product, yearlyEstimatedConsumption, winterFee, spotFee, baseFee);
            } else if (this.spotPrice && ifSpotPriceProduct) {
                const spotPricewithMargin = parseFloat(this.spotPrice) + parseFloat(margin);
                const spotEurokWh = spotPricewithMargin / 100;
                return utils.calculateYearlyAverageSpotPriceTotalBasedOnConsumption(product, yearlyEstimatedConsumption, spotEurokWh, spotPricewithMargin, baseFee);
            }
            return utils.calculateYearlyTotalBasedOnConsumption(product, yearlyEstimatedConsumption, eurokWh, generalFee, baseFee);
        },
        getTranslatedProduct(id){
            const product = this.electricityContractProducts.find((product) => product.ID === id);
            this.form.selectedProduct = {
                ...this.form.selectedProduct,
                Description:product.Description,
                Information: product.Information,
                Name: product.Name,
            }
        },
        async fetchElectricityContracts() {
            const uri = this.getBaseUrl() + '/getAllElectricityProductsAction';
            const data = await fetch(uri);
            this.electricityContractProducts = await data.json();
            this.electricityContractProducts = this.electricityContractProducts
                .filter(product => product.Active)
                .map(product => ({
                    ...product,
                    selectedContractType: product.BaseFee_Default
                }));
        },
        async fetchElectricityMeasurementTypes() {
            const uri = this.getBaseUrl() + '/getElectricityMeasurementTypesAction';
            const data = await fetch(uri);
            this.electricityMeasurementTypes = await data.json();
            if (!this.form.selectedMeasurementType) {
                this.form.selectedMeasurementType = this.electricityMeasurementTypes.length && this.electricityMeasurementTypes[0];
            }
        },
        async fetchHousingTypes() {
            const uri = this.getBaseUrl() + '/getHousingTypesAction';
            const data = await fetch(uri);
            this.housingTypes = await data.json();
            this.setDefaultHousingType();
            if (!this.presetHousingType && !this.form.selectedHousingType) {
                this.form.selectedHousingType = this.housingTypes.length && this.housingTypes[0];
            }
        },
        async fetchYearlySpotPriceTotal() {
            const uri = this.getBaseUrl() + '/getYearlySpotpriceTotalAction';
            const data = await fetch(uri);
            this.spotPrice = await data.json();
        },
        async fetchBillingIntervals() {
            const uri = this.getBaseUrl() + '/getBillingIntervalsAction';
            const data = await fetch(uri);
            this.billingIntervalsList = await data.json();
        },
        saveFormData() {
            const dataCopy = cloneDeep(this.$data);
            sessionStorage.setItem(ELECTRICITY_CONTRACT_DATA_SESSION_STORAGE_KEY, JSON.stringify(dataCopy));
        },
        getFormattedDate(date){
            return moment(date).format("DD-MM-YYYY")
        },
        getFormData() {
            const data = sessionStorage.getItem(ELECTRICITY_CONTRACT_DATA_SESSION_STORAGE_KEY) || JSON.stringify({
                ...initialState,
                isInitialized: true
            });

            if (data) {
                this.data = JSON.parse(data);
                for (let [key, value] of Object.entries(this.data)) {
                    if (key === 'disabledDates') {
                        value = { to: new Date(undefined) };
                    }
                    this[key] = value;
                }
            }
        },
        async getMultiPersonFormData(uuid, token) {
            try {
                const uri = this.getBaseUrl() + `/getMultiPersonFormData?UUID=${uuid}&TOKEN=${token}`;
                const response = await fetch(uri);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const text = await response.text();
                const data = JSON.parse(text);
                if (!this.$data.form) {
                    this.$set(this.$data, 'form', {});
                }
                this.$set(this.$data.form, 'multiPersonRegistration', {
                    ...this.$data.form.multiPersonRegistration,
                    ...data.multiPersonRegistration
                });
                this.$set(this.$data.form, 'optional', data.optional);
                this.saveFormData();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error fetching multi-person form data:', error);
            }
        },
        clearFormData() {
            sessionStorage.removeItem(ELECTRICITY_CONTRACT_DATA_SESSION_STORAGE_KEY);
            this.initialize();
        },
        showModal(modalName) {
            this.$modal.show(modalName);
        },
        async getIsAuthenticated(){
            const uri = this.getBaseUrl() + '/getUserAuthenticated';
            const data = await fetch(uri);
            return data.json();
        },
        setSelectedInterval(interval) {
            this.form.registration.selectedInterval = interval;
        },
        setYearlyTotal(total) {
            this.form.yearlyTotal = total;
        },
        setIsFormValid(valid) {
            this.isFormValid = valid;
        },
        setFormRegistrationStartDate(date) {
            this.form.registration.startDate = date;
        },
    },
    created() {
        this.getFormData();
    },
    async mounted() {
        await this.initialize();

        const urlParams = new URLSearchParams(window.location.search);
        const uuid = urlParams.get('UUID');
        const token = urlParams.get('TOKEN');

        if (uuid && token) {
            await this.getMultiPersonFormData(uuid, token);
        }
        if(this.form.selectedProduct !== undefined && this.form.selectedProduct !== null){
            this.goToNewPortal(this.form.selectedProduct.ID);
        }
        this.goBack();
    },
    updated() {
        if (typeof $ !== 'undefined') {
            // eslint-disable-next-line no-undef
            $('[data-toggle="tooltip"]').tooltip();
        } else {
            // eslint-disable-next-line no-console
            console.error('jQuery is not loaded');
        }
    },
    computed: {
        getBillingIntervals(){
            let options = [];
            for (let interval of this.billingIntervalsList) {
                options.push({text: interval.Name, value: interval})
                if(interval.SortOrder === 0){
                    this.setSelectedInterval(interval);
                }
            }
            return options;
        },

        getDisplayProducts(){
            let productList = [];
            for(let type of this.electricityMeasurementTypes){
                let products = this.getProductsByMeasurmentType(type.ID);
                for(let product of products) {
                    productList.push(product)
                }
            }

            return productList.sort((a,b ) => a.SortOrder - b.SortOrder)
        },
        filteredProducts() {
            const products = this.electricityContractProducts;
            return products.filter(product => this.productHasSelectedMeasurementType(product));
        },
        highlightedProduct() {
            const products = this.electricityContractProducts;
            return products.find(product => product.Highlight);
        },
        getFeesForHighlightedProductPrices() {
            const products = this.electricityContractProducts;
            const product = products.find(product => product.Highlight);
            if (!product) {
                return null;
            }
            /*
                Calculate fees shown on product based on selected contract duration in months.
            */
            const baseFee = product[`BaseFee_${product.selectedContractType}`];
            const generalFee = product[`GenFee_${product.selectedContractType}`];
            const yearlyEstimatedConsumption = 2000;
            const eurokWh = generalFee / 100;
            const dayPrice = product[`DayFee_${product.selectedContractType}`];
            const nightPrice = product[`NightFee_${product.selectedContractType}`];
            const seasonalFee_27 = product[`SeasonalFee27_${product.selectedContractType}`];
            const seasonalFee_73 = product[`SeasonalFee73_${product.selectedContractType}`];
            const winterFee = product[`WinterFee_${product.selectedContractType}`];
            const spotFee = product[`SpotFee_${product.selectedContractType}`];
            const ifSpotPriceProduct = product.SpotPriceProduct;
            const margin = product.SpotMarginCents;
            if (dayPrice && nightPrice) {
                return utils.calculateDayAndNightPrice(product, dayPrice, nightPrice, yearlyEstimatedConsumption, baseFee);
            } else if (seasonalFee_27 && seasonalFee_73) {
                return utils.calculateSeasonalPrices(product, yearlyEstimatedConsumption, seasonalFee_27, seasonalFee_73, baseFee);
            } else if (winterFee && spotFee) {
                return utils.calculateWinterAndSpotPrices(product, yearlyEstimatedConsumption, winterFee, spotFee, baseFee);
            } else if (this.spotPrice && ifSpotPriceProduct) {
                const spotPricewithMargin = parseFloat(this.spotPrice) + parseFloat(margin);
                const spotEurokWh = spotPricewithMargin / 100;
                return utils.calculateYearlyAverageSpotPriceTotalBasedOnConsumption(product, yearlyEstimatedConsumption, spotEurokWh, spotPricewithMargin, baseFee);
            }
            return utils.calculateYearlyTotalBasedOnConsumption(product, yearlyEstimatedConsumption, eurokWh, generalFee, baseFee);
        },
        selectedProductPrices() {
            const selectedProductIndex = this.calculatedProductPrices.findIndex(p => {
                this.setYearlyTotal(p.totalSum);
                return p.ID === this.form.selectedProduct.ID
            });
            return this.calculatedProductPrices[selectedProductIndex];
        },
        calculatedProductPrices() {
            const products = this.electricityContractProducts;
            const sliderValue = this.slider.value;
            return products.filter(product => this.productHasSelectedMeasurementType(product))
                .map(product => {
                    /*
                        Calculate fees shown on product based on selected contract duration in months.
                     */
                    const baseFee = product[`BaseFee_${product.selectedContractType}`];
                    const generalFee = product[`GenFee_${product.selectedContractType}`];
                    const yearlyEstimatedConsumption = sliderValue || 0;
                    const eurokWh = generalFee / 100;
                    const dayPrice = product[`DayFee_${product.selectedContractType}`];
                    const nightPrice = product[`NightFee_${product.selectedContractType}`];
                    const seasonalFee_27 = product[`SeasonalFee27_${product.selectedContractType}`];
                    const seasonalFee_73 = product[`SeasonalFee73_${product.selectedContractType}`];
                    const winterFee = product[`WinterFee_${product.selectedContractType}`];
                    const spotFee = product[`SpotFee_${product.selectedContractType}`];
                    const ifSpotPriceProduct = product.SpotPriceProduct;
                    const margin = product.SpotMarginCents;
                    if (dayPrice && nightPrice) {
                        return utils.calculateDayAndNightPrice(product, dayPrice, nightPrice, yearlyEstimatedConsumption, baseFee);
                    } else if (seasonalFee_27 && seasonalFee_73) {
                        return utils.calculateSeasonalPrices(product, yearlyEstimatedConsumption, seasonalFee_27, seasonalFee_73, baseFee);
                    } else if (winterFee && spotFee) {
                        return utils.calculateWinterAndSpotPrices(product, yearlyEstimatedConsumption, winterFee, spotFee, baseFee);
                    } else if (this.spotPrice && ifSpotPriceProduct) {
                        const spotPricewithMargin = parseFloat(this.spotPrice) + parseFloat(margin);
                        const spotEurokWh = spotPricewithMargin / 100;
                        return utils.calculateYearlyAverageSpotPriceTotalBasedOnConsumption(product, yearlyEstimatedConsumption, spotEurokWh, spotPricewithMargin, baseFee);
                    }
                    return utils.calculateYearlyTotalBasedOnConsumption(product, yearlyEstimatedConsumption, eurokWh, generalFee, baseFee);
                });
        },
        formValid() {
            this.setIsFormValid(utils.validateForm(this.form));
            return this.isFormValid;
        },
        datepickerSelection() {
            if (this.form.registration.startDate == null) {
                return 'is-invalid'
            } else {
                return 'is-valid'
            }
        },
        disabledDates() {

            const defaultCurrentAddressStartDate = () => {
                if(moment(utils.getDateForDaysAhead(15)).isBetween(moment(disabledDates.ranges[0].from),
                    moment(disabledDates.ranges[0].to))){
                    return utils.getDateWithTimezone("2022-03-08")
                }else {
                    return utils.getDateForDaysAhead(15);
                }
            }
            const defaultNewAddressStartDate = utils.getDateForDaysAhead(4);
            const fromRange = this.form.registration.isNewAddress ? new Date() :
                new Date("2022-02-01");
            const toRange = this.form.registration.isNewAddress ?  utils.getDateForDaysAhead(3) :
                new Date("2022-03-08");

            const disabledDates = {
                to: this.form.registration.isNewAddress ?
                    utils.getDateForDaysAhead(3) : utils.getDateForDaysAhead(14),
                from: utils.getDateForDaysAhead(90),
                ranges: [{
                    from: fromRange,
                    to: toRange
                }]
            }

            const selectedStartDateIsAllowed = moment(this.form.registration.startDate).isBetween(moment(disabledDates.to), moment(disabledDates.from));
            const selectedStartDateIsInRange = moment(this.form.registration.startDate).isBetween(moment(disabledDates.ranges[0].from), moment(disabledDates.ranges[0].to));
            if (!selectedStartDateIsAllowed || selectedStartDateIsInRange) {
                this.setFormRegistrationStartDate(this.form.registration.isNewAddress ? defaultNewAddressStartDate : defaultCurrentAddressStartDate());
            }
            return disabledDates;
        },
        isSecondPersonSocialSecurityNumberValid() {
            return utils.validateSocialSecurityNumber(this.form.registration.secondPersonSocialSecurityNumber);
        }
    },
    watch: {
        'form': {
            handler() {
                this.isInitialized && this.saveFormData();
            },
            deep: true
        },
        'slider.value': function() {
            this.isInitialized && this.saveFormData();
        },
        'formStage': function() {
            this.isInitialized && this.saveFormData();
        }
    }
});
